module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1018-8b6706184a5a6e9b313b8ba447c58e0e.png";